"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.finalPropertySchema = void 0;
var constants_1 = require("@hobt/constants");
var address_schema_1 = require("./address-schema");
exports.finalPropertySchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['address'],
    properties: {
        address: address_schema_1.addressSchema,
        bedCount: {
            type: ['number', 'null'],
            minimum: 0,
            maximum: 99999.99,
            decimal: [7, 2],
            errorMessage: 'Should be a decimal with up to 7 digits in total and 2 digits of precision or null',
        },
        buildingTypeCode: {
            type: ['string', 'null'],
            enum: __spreadArrays(Object.values(constants_1.BuildingType), [null]),
            errorMessage: 'Should equate to a valid BuildingType Enum value or null',
        },
        completeLegalDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 460,
            errorMessage: 'Should be a string with a maximum of 460 characters or null',
        },
        legalBlockDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 5,
            errorMessage: 'Should be a string with a maximum of 5 characters or null',
        },
        legalConcessionDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 3,
            errorMessage: 'Should be a string with a maximum of 3 characters or null',
        },
        legalLevelDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2,
            errorMessage: 'Should be a string with a maximum of 2 characters or null',
        },
        legalLotDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 20,
            errorMessage: 'Should be a string with a maximum of 20 characters or null',
        },
        legalPlanDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 12,
            errorMessage: 'Should be a string with a maximum of 12 characters or null',
        },
        legalTownshipDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 6,
            errorMessage: 'Should be a string with a maximum of 6 characters or null',
        },
        legalUnitDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 4,
            errorMessage: 'Should be a string with a maximum of 4 characters or null',
        },
        unitCount: {
            type: ['number', 'null'],
            minimum: 0,
            maximum: 99999.99,
            decimal: [7, 2],
            errorMessage: 'Should be a decimal with up to 7 digits in total and 2 digits of precision or null',
        },
    },
};
